import { render, staticRenderFns } from "./ValidationPreResa.vue?vue&type=template&id=126f14ac&"
import script from "./ValidationPreResa.vue?vue&type=script&lang=js&"
export * from "./ValidationPreResa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports